// extracted by mini-css-extract-plugin
export default {"root":"styles_root__stVYO","active":"styles_active__BLzNa","usetoggle":"styles_usetoggle__sGjHe","switch":"styles_switch__SF+kP"};